import { render, staticRenderFns } from "./AddFirst.vue?vue&type=template&id=5bca4cd4&scoped=true&"
import script from "./AddFirst.vue?vue&type=script&lang=js&"
export * from "./AddFirst.vue?vue&type=script&lang=js&"
import style0 from "./AddFirst.vue?vue&type=style&index=0&id=5bca4cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca4cd4",
  null
  
)

export default component.exports